const MAIL_ORDER = 1
const RETAIL = 8
const SPECIALTY = 16
const LONG_TERM_CARE = 32
const OPEN_24 = 64

const Cortege = [
  [MAIL_ORDER, 'Mail Order'],
  [RETAIL, 'Retail'],
  [SPECIALTY, 'Specialty'],
  [LONG_TERM_CARE, 'Long Term Care'],
  [OPEN_24, 'Open 24 hours'],
]
const convertSpecialty = (mask) => (mask ? Cortege.flatMap(([bit, str]) => (mask & bit ? [str] : [])).join(', ') : '')

export default convertSpecialty
